import { F } from './tokens';

interface PillProps {
  text: string;
  color: string;
  bg: string;
}

export function Pill({ text, color, bg }: PillProps) {
  return (
    <span style={{
      fontSize: 10, padding: '3px 8px', borderRadius: 99,
      background: bg, color, fontFamily: F.mono,
      fontWeight: 600, letterSpacing: 0.5,
    }}>
      {text}
    </span>
  );
}
